"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M4.7071 12.6929c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142l4.8295 4.8295c.3913.3913 1.0259.3905 1.4161-.0018L20.709 7.7052c.3895-.3915.3878-1.0247-.0038-1.4142-.3915-.3895-1.0247-.3878-1.4142.0038L8.8277 16.8135 4.707 12.6929z"
})), 'CheckIcon');
/* eslint-enable */


exports["default"] = _default;